module.exports = __webpack_public_path__ + "e2c502ef0523176fff3671fa724c74ff.png";